import { ApolloClient, InMemoryCache, createHttpLink, ApolloProvider } from "@apollo/client";
import App from '../App';
import {setContext} from "@apollo/client/link/context";

const authLink = setContext(() => {
    const token = localStorage.getItem('jwtToken');
    return {
        headers: {
            Authorization: token ? `Bearer ${token}` : ''
        }
    }
})

const httpLink = createHttpLink({
    // uri: 'http://localhost:5000'
    uri: 'https://vast-mountain-47744.herokuapp.com/'
})

const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache()
})

export default (
    <ApolloProvider client={client}>
        <App />
    </ApolloProvider>
);
